import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'
import { managerOrderMeta } from '../routes/metaData'
const DefaultManagerOrderScreen = observer((props: any) => {
   const history = useHistory()
   useEffect(() => {
      history.push(managerOrderMeta[0].path)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   return null
})

export default DefaultManagerOrderScreen
